import * as Yup from 'yup';
import OrderAcceptedIcon from '../../../app/components/svgIcons/OrderAcceptedIcon';
import OrderDesignedIcon from '../../../app/components/svgIcons/OrderDesignedIcon';
import OrderOnDeliveryIcon from '../../../app/components/svgIcons/OrderOnDeliveryIcon';
import OrderInDesignIcon from '../../../app/components/svgIcons/OrderInDesignIcon';
import OrderDeliveredIcon from '../../../app/components/svgIcons/OrderDeliveredIcon';

export const orderSchema = Yup.object().shape({
  customerData: Yup.object().required('Please Select a Customer'),
  orderNo: Yup.string()
    .max(10, 'Order number cannot contain more than 10 characters')
    .required('Please Select a order number'),
  orderNotes: Yup.string().required('Please Add Order Notes'),
  vendor: Yup.object().required('Please Select a Vendor'),
  chooseProduct: Yup.object().required('Please Select at least 1 product'),
  delDate: Yup.string().required('Please select delivery date'),
  rCompany: Yup.string(),
  rFirst: Yup.string(),
  rLast: Yup.string(),
  rAddress: Yup.string(),
  // rPhone: Yup.string().matches(phoneRegExp, 'Phone number is not valid'),
  rCity: Yup.string(),
  rState: Yup.string(),
  rZip: Yup.string().max(6, 'Post code must be 6 characters'),
  // salesTax: Yup.string().required('Please add sales tax'),
  // serviceCharge: Yup.string().required('Please service fee'),
  salesTax: Yup.string().when('visibleFields', {
    is: (visibleFields) => visibleFields?.some((key) => key === 'Sales Tax'),
    then: Yup.string().required('Sales tax is required'),
    otherwise: Yup.string().nullable(),
  }),
  serviceCharge: Yup.string().when('visibleFields', {
    is: (visibleFields) => visibleFields?.some((key) => key === 'Service Fee'),
    then: Yup.string().required('Service fee is required'),
    otherwise: Yup.string().nullable(),
  }),
});
export const OrderDefaultValues = {
  customerData: '',
  orderNo: '',
  vendor: undefined,
  orderNotes: '',
  chooseProduct: undefined,
  products: [],
  delDate: undefined,
  rCompany: '',
  rFirst: '',
  rLast: '',
  rAddress: '',
  rPhone: undefined,
  rCity: '',
  rState: '',
  rZip: '',
  salesTax: undefined,
  serviceCharge: undefined,
};

export const orderStatuses = {
  ORDER_RECEIVED: 1,
  ORDER_ASSIGNED: 2,
  ORDER_ACCEPTED: 3,
  ORDER_IN_DESIGN: 4,
  ORDER_READY_FOR_DELIVERY: 5,
  ORDER_OUT_ON_DELIVERY: 6,
  ORDER_DELIVERED: 7,
  ORDER_REJECTED: 8,
};

export const orderStatusesList = [
  {
    name: 'Accepted',
    value: orderStatuses.ORDER_ACCEPTED,
    active: false,
    icon: OrderAcceptedIcon,
  },
  {
    name: 'In Design',
    value: orderStatuses.ORDER_IN_DESIGN,
    active: false,
    icon: OrderInDesignIcon,
  },
  {
    name: 'Ready for Delivery',
    value: orderStatuses.ORDER_READY_FOR_DELIVERY,
    active: false,
    icon: OrderDesignedIcon,
  },
  {
    name: 'Out On Delivery',
    value: orderStatuses.ORDER_OUT_ON_DELIVERY,
    active: false,
    icon: OrderOnDeliveryIcon,
  },
  {
    name: 'Delivered',
    value: orderStatuses.ORDER_DELIVERED,
    active: false,
    icon: OrderDeliveredIcon,
  },
];
